import React from 'react'
import './index.scss'
import { Link } from "gatsby"

const AppointmentIndividual = ({
  subTitle = 'Sie benötigen eine',
  title = 'Individual-Software?',
  text = '',
  linkText = 'Mehr erfahren',
  linkURL = '/individual-software',
  noImage,
  image,
}) => (
  <div className="appointmentindividual">
    <div className="appointmentindividual__container">
      <span>{subTitle}</span>
      <h2>{title}</h2>
      {text.length>0 && <p>{text}</p>}
      <Link to={linkURL} className="button">
        {linkText}
      </Link>
      {
        noImage
          ? ''
          : <img src={image} loading='lazy' />
      }
    </div>
  </div>
)

export default AppointmentIndividual
